import { CheckCircleFilled } from "@ant-design/icons";
import { Divider, Flex, Typography } from "antd";
import React, { useContext } from "react";
import CalendarSlot from "../../Components/Calender/CalenderSlot";
import { DashboardContext } from "../../Context/DashboardContext";

interface SlotPickerProps {
  onSlotBooked: () => void;
}

const SlotPicker: React.FC<SlotPickerProps> = ({ onSlotBooked }) => {
  const { appliedJob, jobDescription } = useContext(DashboardContext);

  if (!appliedJob || !jobDescription) {
    console.log("SlotPicker line 15: No job post or job application found");
    return null;
  }
  return (
    <Flex align="center" justify="center" style={{ flexDirection: "column" }}>
      <Typography.Title level={4}>
        <CheckCircleFilled style={{ color: "#00b96b" }} /> Congratulations
      </Typography.Title>
      <Typography.Title
        type="secondary"
        level={5}
        style={{ textAlign: "center" }}
      >
        You're qualified for an online interview with us, kindly confirm
        available slots from below.
      </Typography.Title>
      <Divider></Divider>
      <CalendarSlot onSlotBooked={onSlotBooked} appliedJob={appliedJob} jobPostId={jobDescription._id}/>
    </Flex>
  );
};

export default SlotPicker;
